import React from 'react';
import { Dimensions, Platform } from 'react-native';


export const PHONE_SIZE: number = 576; // Extra small devices (portrait phones, less than 576px)
export const LANDSCAPE_PHONE_SIZE: number = 576; // Small devices (landscape phones, 576px and up)
export const TABLET_SIZE: number = 768;  // Medium devices (tablets, 768px and up)
export const DESKTOP_SIZE: number = 992;  // Large devices (desktops, 992px and up)
export const LARGE_DESKTOP_SIZE: number = 1200;  // Extra large devices (large desktops, 1200px and up)


const VIEW_TYPE: string = Platform.OS === 'web' ? 'window' : 'screen';

export const useScreenDimensions = () => {
    const [screenData, setScreenData] = React.useState(Dimensions.get('screen'));

    React.useEffect(() => {
        const onChange = (result) => {
            // console.log('Dimensions.addEventListener(change, onChange);', result);
            setScreenData(result[VIEW_TYPE])
        };
        Dimensions.addEventListener('change', onChange);
        return () => Dimensions.removeEventListener('change', onChange);
    });
    
    const dimensionInfo = {
        ...screenData,
        isMediumScreenOrLarger: screenData.width >= TABLET_SIZE, 
        isLargeScreenOrLarger: screenData.width >= DESKTOP_SIZE,
        isYugeScreenOrLarger: screenData.width >= LARGE_DESKTOP_SIZE,
        isLandscape: screenData.width > screenData.height,
    };
    const itemWidths = getItemWidth({
        isMediumScreenOrLarger: dimensionInfo.isMediumScreenOrLarger,
        isLargeScreenOrLarger: dimensionInfo.isLargeScreenOrLarger
    });
    // console.log('dimensionInfo has changed: ', dimensionInfo);
    return {...dimensionInfo, ...itemWidths};
};


export function getItemWidth(screenData: any): { bodyWidth: number; cardWidth: number; sectionSpace: number; pageSpacerHorizontal: number; } {
    const { isMediumScreenOrLarger, isLargeScreenOrLarger } = screenData;

    
    const bodyWidth: any = isLargeScreenOrLarger ? 900 : ( isMediumScreenOrLarger ? 600 : undefined );
    const cardWidth: any = isLargeScreenOrLarger ? 279 : ( isMediumScreenOrLarger ? 279 : undefined );
    const sectionSpace: number = bodyWidth ? 60 : 40;
    const pageSpacerHorizontal: number = isLargeScreenOrLarger ? 150 : ( isMediumScreenOrLarger ? 50 : 0 );
    // const pageSpacerHorizontal: number = isMediumScreenOrLarger ? 50 : 0;
    // const PAGE_PADDING

    return {
        bodyWidth,
        pageSpacerHorizontal,
        cardWidth,
        sectionSpace
    };
}